import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBotIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 21,
	viewBox: "0 0 22 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5071 6.96558H4.38739C3.83001 6.96558 3.37817 7.42151 3.37817 7.98394V18.1676C3.37817 18.73 3.83001 19.186 4.38739 19.186H17.5071C18.0645 19.186 18.5163 18.73 18.5163 18.1676V7.98394C18.5163 7.42151 18.0645 6.96558 17.5071 6.96558Z",
			stroke: "#2A2A30",
			strokeWidth: 1.71023
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.41497 12.0572C7.97235 12.0572 8.42419 11.6013 8.42419 11.0389C8.42419 10.4764 7.97235 10.0205 7.41497 10.0205C6.8576 10.0205 6.40576 10.4764 6.40576 11.0389C6.40576 11.6013 6.8576 12.0572 7.41497 12.0572Z",
			fill: "#2A2A30"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4794 12.0572C15.0368 12.0572 15.4886 11.6013 15.4886 11.0389C15.4886 10.4764 15.0368 10.0205 14.4794 10.0205C13.9221 10.0205 13.4702 10.4764 13.4702 11.0389C13.4702 11.6013 13.9221 12.0572 14.4794 12.0572Z",
			fill: "#2A2A30"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.92889 14.094C8.66123 14.094 8.40453 14.2013 8.21527 14.3923C8.02601 14.5832 7.91968 14.8423 7.91968 15.1124C7.91968 15.3824 8.02601 15.6415 8.21527 15.8325C8.40453 16.0234 8.66123 16.1307 8.92889 16.1307V14.094ZM12.9657 16.1307C13.2334 16.1307 13.4901 16.0234 13.6794 15.8325C13.8686 15.6415 13.9749 15.3824 13.9749 15.1124C13.9749 14.8423 13.8686 14.5832 13.6794 14.3923C13.4901 14.2013 13.2334 14.094 12.9657 14.094V16.1307ZM8.92889 16.1307H12.9657V14.094H8.92889V16.1307Z",
			fill: "#2A2A30"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9473 2.89209V6.96555M0.855225 11.039V15.1125M21.0395 11.039V15.1125",
			stroke: "#2A2A30",
			strokeWidth: 1.71023,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9472 2.89196C11.5046 2.89196 11.9564 2.43602 11.9564 1.87359C11.9564 1.31116 11.5046 0.855225 10.9472 0.855225C10.3898 0.855225 9.93799 1.31116 9.93799 1.87359C9.93799 2.43602 10.3898 2.89196 10.9472 2.89196Z",
			stroke: "#2A2A30",
			strokeWidth: 1.71023
		})
	]
});
const ForwardRef = forwardRef(SvgBotIcon);
export { ForwardRef as ReactComponent };
